<template :style="$i18n.locale=='en' ? 'direction:ltr' : 'direction:rtl'">
  <div
    class="c-app flex-row align-items-center"
    style="
      background-image: url('../../../img/trackingBack.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    "
  >
    <!--<img src="../../assets/image/loginBack.jpg"/>-->
    <CContainer
      :style="$i18n.locale == 'en' ? 'direction:ltr' : 'direction:rtl'"
    >
      <CRow class="justify-content-center">
        <CCol md="5">
          <CCardGroup>
            <CCard class="pt-0 px-4" style="opacity: 0.92">
              <CCardBody>
                <CForm class="needs-validation">
                  <CRow class="mb-2">
                    <CImg
                      src="../../../img/logoict.png"
                      class="col-5"
                      align="center"
                    ></CImg
                  ></CRow>
                  <CRow v-if="spinner" class="justify-content-center mt-2">
                    <div class="spinner-grow text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <div class="spinner-grow text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <div class="spinner-grow text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </CRow>

                  <h1 class="text-center">{{ $t("loginHeader") }}</h1>
                  <p class="text-muted text-center">
                    {{ $t("loginHeaderMessage") }}
                  </p>
                  <CInput
                    :placeholder="$t('username')"
                    autocomplete="username email"
                    required
                    v-model="loginInfo.username"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    :placeholder="$t('password')"
                    type="password"
                    autocomplete="curent-password"
                    required
                    v-model="loginInfo.password"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>

                  <label class="text-muted">
                    {{ $t("captcha") }}
                    <span id="InputLoginCaptcha" style="color: #990000"></span>
                  </label>
                  <CInput
                    type="number"
                    :placeholder="$t('sum')"
                    required
                    v-model="loginInfo.captcha"
                  ></CInput>
                  <div
                    style="
                      display: flex;
                      margin-top: 5px;
                      justify-content: center;
                      align-item: center;
                    "
                    class="my-2"
                  >
                    <a
                      style="
                        cursor: pointer;
                        float: left;
                        padding-left: 5px;
                        padding-right: 10px;
                        padding-top: 4px;
                      "
                      v-on:click="chagenCaptcha"
                    >
                      <CIcon
                        size="xl"
                        class="text-danger"
                        name="cil-loop-circular"
                      />
                    </a>
                    <img
                      :src="imgCaptcha"
                      alt="Captcha"
                      id="LoginCaptcha"
                      style="float: left"
                    />
                  </div>

                  <CCol col="12" class="text-center">
                    <CButton
                      class="btn px-4 col-12 btn-primary"
                      v-on:click="submitForm"
                      >{{ $t("btnLogin") }}</CButton
                    >
                  </CCol>
                  <!-- <CCol col="12" class="text-center">
                    <router-link
                      class="btn px-4 col-12"
                      :to="{ name: 'ForgetPassword' }"
                      >{{ $t("forgetPassword") }}</router-link
                    >
                  </CCol> -->
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <CModal
      :title="$t('errorLoginHeader')"
      color="danger"
      :show.sync="showModal"
      fade
      size="lg"
      :style="$i18n.locale == 'en' ? 'direction:ltr' : 'direction:rtl'"
    >
      {{
        textModal == "captcha"
          ? $t("captchError")
          : textModal == "userPassError"
          ? $t("userPassError")
          : $t("inactiveAccount")
      }}
      <template #footer>
        <CButton @click="showModal = false" color="danger">{{
          $t("accept")
        }}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import router from "../../router";
import axios from "axios";
import { Values } from "../../../src/commonValues.js";
import { setAuthToken } from "../../../src/services/AuthService.js";
export default {
  name: "Login",

  //****************************************************************************************** data */
  data() {
    return {
      loginInfo: { username: "", password: "", captcha: "" },
      call_api: true,
      imgCaptcha: "",
      valueCaptch: "",
      showModal: false,
      textModal: "",
      spinner: false,
    };
  },

  //*****************************************************************************************/ mounts
  mounted() {
    //const config = { headers: { "Content-Type": "application/json",'Access-Control-Allow-Origin' : '*', } };
    // { withCredentials: true } or axios.defaults.withCredentials = true

   console.log("Page hostname is " + window.location.hostname);
    axios.get(Values.serverIp + "Captcha").then((response) => {
      this.setChapcha(response.data);
    });

    //router.push({ name: "ChangePasswordPage", query: { username: "this.loginInfo.username" }});

    

  },

  //***************************************************************************************** components */
  components: {},

  //****************************************************************************************** methods */
  methods: {
    //****************************** change captcha */
    chagenCaptcha: function (value) {
      //const config = { headers: { "Content-Type": "application/json" } };
      axios
        .get(Values.serverIp + "Captcha", {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.setChapcha(response.data);
        });
    },
    //****************************** set captcha*/
    setChapcha: function (value) {
      this.imgCaptcha = value.substring(0, value.indexOf("&"));
      this.valueCaptch = value.substring(value.indexOf("&") + 1);
    },
    //*************************** form validation
    submitForm: function () {
      var forms = document.querySelectorAll(".needs-validation");
      //console.log(forms);

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          this.call_api = false;
        } else if (
          forms[0][i].type == "password" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          this.call_api = false;
        } else if (
          forms[0][i].type == "number" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
          this.call_api = false;
        }
      }

      if (this.call_api) {
        if (this.valueCaptch == this.loginInfo.captcha) {
          this.spinner = true;
          axios
            .post(Values.serverIp + "Account/Authenticate", {
              //Areas/AdminPanel/
              userName: this.loginInfo.username,
              password: this.loginInfo.password,
              captcha: this.loginInfo.captcha,
            })
            .then((response) => {
              console.log(response.data);
              if (response.data == 1) {
                (this.spinner = false), (this.textModal = "userPassError");
                this.showModal = true;
                this.chagenCaptcha();
              } else if (response.data == 2) {
                (this.spinner = false), (this.textModal = "inactiveAccount");
                this.showModal = true;
                this.chagenCaptcha();
              } else {
                //console.log(response.data.carsGroupIds);
                
                setAuthToken(
                  response.data.jwtToken,
                  this.loginInfo.username,
                  response.data.name,
                  response.data.userImagePath,
                  response.data.changePasswordStatus
                );
                this.spinner = false;
                if(response.data.changePasswordStatus==0)
                  router.push({ name: "Home" });
                else
                  router.push({ name: "ChangePasswordPage"});
              }
            });
        } else {
          (this.spinner = false), (this.textModal = "captcha");
          this.showModal = true;
          this.chagenCaptcha();
        }
        //  router.push({ name: "Home" });
      }

      this.call_api = true;
    },
  },
  //***************************** */ end methods
};
</script>


